import React, { Component } from 'react';
import { withRouter } from "react-router";
import { connect } from "react-redux";
import CommonHeaderComponent from "../headers/CommonHeaderComponent";
import * as actions from "../../actions/ordersAction";
import { bindActionCreators } from 'redux';
import * as symbols from "../../operations/symbols";
import LoaderComponent from "../core/LoaderComponent";

class PhoneListComponent extends Component {

  constructor(props) {
    super(props);

    this.state = {
      phones: [],
      selectedPhone: null,
      noPhonesData: false,
      prodEnv: false
    }
  }

  componentDidMount() {
    if (!process.env.REACT_APP_API_ENDPOINT && process.env.NODE_ENV === 'production') {
      this.setState({ prodEnv: true });
      this.props.actions.getOrderPhones(this.props.match.params.id);

    } else {
      this.setState({ selectedPhone: this.props.user && this.props.user.phone })
    }
  }

  componentDidUpdate(prevProps) {
    const { getPhonesStatus, orders, sendDeliveryOtpStatus } = this.props;
    if (orders.orderPhones && getPhonesStatus !== prevProps.getPhonesStatus && getPhonesStatus === symbols.STATUS_DONE) {
      this.setState({ phones: orders.orderPhones })
    }
    if (getPhonesStatus !== prevProps.getPhonesStatus && getPhonesStatus === symbols.STATUS_FAIL) {
      this.setState({ noPhonesData: true })
    }
    if (sendDeliveryOtpStatus !== prevProps.sendDeliveryOtpStatus && sendDeliveryOtpStatus === symbols.STATUS_DONE) {
      this.props.sendOtpDone(this.state.selectedPhone)
    }

  }

  handlePhoneClick() {
    this.props.actions.sendDeliveryOtp({ phoneNumber: this.state.selectedPhone, orderId: parseInt(this.props.match.params.id) })
  }

  handleOptionChange(val) {
    this.setState({ selectedPhone: val })
  }

  render() {
    return (
      this.props.sendDeliveryOtpStatus === symbols.STATUS_BEGIN ?
      <LoaderComponent/> :
      <div className='mh-100'>
        {
          this.state.noPhonesData ?
            <div className="phone-card fs-14 pd-top-20">
              <div className="mb-2 red-text">No Phones Mapped!!!</div>
              Please ask the merchant to contact Hyperpure (+91 11 71565093 / help@hyperpure.com)
            </div>
            :
            <form>
            {
              this.state.prodEnv ?
              <React.Fragment>
              {
                this.state.phones.map((ele, index) =>
                  <label className="input-radio-wrapper mb-2 fs-14">
                    <div className="label-wrap">
                      <input 
                        type="radio"
                        value="option1" 
                        checked={this.state.selectedPhone === ele.phoneNumber} 
                        onChange={() => this.handleOptionChange(ele.phoneNumber)}
                      />
                      <div className="checked"></div>
                    </div>
                    <span className="phone-title">
                      {ele.name}
                      <div className="right okra-med">{ele.phoneNumber}</div>
                      <div className="clearfix"/>
                     </span>
                  </label>
                )
              }
              </React.Fragment>
              : <label className="input-radio-wrapper mb-2 fs-14">
                <div className="label-wrap">
                  <input 
                    type="radio"
                    value="option1" 
                    checked={true} 
                    onChange={() => this.handleOptionChange(this.props.user && this.props.user.phone)}
                  />
                  <div className="checked"></div>
                </div>
                  <span className="phone-title">
                    Self (for testing)
                    <div className="right okra-med">{this.props.user && this.props.user.phone}</div>
                    <div className="clearfix"/>
                   </span>
              </label>
            }
            
          <div className="order-card fixed-verify-section z-index-9">
              <div
                className={this.state.selectedPhone ? "btn btn-green-flat btn-expand btn-green":  "btn btn-green-flat btn-expand btn-disabled"  }
                onClick={() => this.handlePhoneClick()}
              >
                Send OTP
              </div>
            </div>
          </form>
        }
      </div>
    )
  }
}

export default withRouter(connect(
  state => ({
    getPhonesStatus: state.statuses.getOrderPhones.status,
    getPhonesError: state.statuses.getOrderPhones.error,
    sendDeliveryOtpStatus: state.statuses.sendDeliveryOtp.status,
    sendDeliveryOtpError: state.statuses.sendDeliveryOtp.error,
    orders: state.orders,
    user: state.auth.user
  }),
  dispatch => ({
    actions: bindActionCreators(actions, dispatch),
  }),
)(PhoneListComponent));
